import { getUser } from "./authService";
import http, { host } from "./httpService";
import { standerdDate, standerdDateForDataCreation } from "../utils/dataFilter";

export const getFiveMDailyContainerPlanning = async (date) => {
  return await http.get(host + "GetDailyContainerPlanning5MData", {
    params: { _DDate: date },
  });
};

export const uploadFiveMDailyPlan = async (plan) => {
  return await http.post(host + "AddDailyContainerPlanning5MData", {
    _jsonDailyplan5Mlist: plan,
  });
};

export const getFiveMMonthlyContainerPlanning = async (month) => {
  return await http.get(host + "GetMonthlyContainerPlanning5MDataJD", {
    params: { planningMonth: month },
  });
};
export const getDailyContainerPlanningFiveM = async (month) => {
  return await http.get(host + "GetDailyFiveMShipmentActualData", {
    params: { _jdmonth: month },
  });
};
export const getFiveMWeeklyPlan = async (month, type) => {
  return await http.get(
    host + "GetWeeklyContainerPlanning5MFromMonthlySheetJD",
    { params: { planningMonth: month, Type: type } }
  );
};

export const createFiveMMonthlyPlan = async (plan) => {
  return await http.post(host + "AddMonthlyContainerPlanning5MData", {
    _jsonMonthlyCont5Mlist: plan,
  });
};

export const insertFiveMBookingNumber = async ({
  DailyContainerPlanning5MId,
  BookingNo,
  BookedBy
}) => {
  const formData = new FormData();
  formData.append("DailyContainerPlanning5MId", DailyContainerPlanning5MId);
  formData.append("BookingNo", BookingNo);
  formData.append("BookedBy", BookedBy);
  return await http.post(
    host + "AddBookingNumberForDailyContainerPlanning5M",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const insertBulkFiveMBookingNumber = async (data) => {
  return await http.post(host + "AddFiveMBulckBooking", {
    _jsonFiveMBookingList: data,
  });
};

export const updateBulkFiveMBookingNumberWithReason = async (data) => {
  return await http.put(host + "UpdateBulk5MBookingNumberWithReason", {
    _json5mNowithReason: data,
  });
};

export const updateFiveMBookingNumber = async ({
  AssignContainer5MId,
  BookingNo,
  BookedBy,
}) => {
  const formData = new FormData();
  formData.append("assignContainerPlanning5MId", AssignContainer5MId);
  formData.append("bookingNo", BookingNo);
  formData.append("bookedBy", BookedBy);
  return await http.put(
    host + "UpdateBookingNumberForDailyContainerPlanning5M",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const update5MContainer = async (formData) => {
  return await http.put(host + "Update5MContainerNumber", formData);
};

export const update5MBulkContainer = async (data) => {
  return await http.put(host + "UpdateFiveMbulkContainerNumber", data);
};

export const sendFiveMReasonsToJD = async ({
  DailyContainerPlanning5MId,
  Reason,
  manualReason,
  SendApprovalBy,
}) => {
  if (Reason === "" && manualReason !== "") {
    const formData = new FormData();
    formData.append("DailyContainerPlanning5MId", DailyContainerPlanning5MId);
    formData.append("Reason", `${manualReason}`);
    formData.append("SendApprovalBy", SendApprovalBy);
    return await http.post(host + "AddSendReason5MToJD", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  else if(Reason !== "" && manualReason !== ""){
    const formData = new FormData();
    formData.append("DailyContainerPlanning5MId", DailyContainerPlanning5MId);
    formData.append("Reason", `${Reason}, ${manualReason}`);
    formData.append("SendApprovalBy", SendApprovalBy);
    return await http.post(host + "AddSendReason5MToJD", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }else{
    const formData = new FormData();
    formData.append("DailyContainerPlanning5MId", DailyContainerPlanning5MId);
    formData.append("Reason", Reason);
    formData.append("SendApprovalBy", SendApprovalBy);
    return await http.post(host + "AddSendReason5MToJD", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
};

export const sendBulkReasonsforhold= async (data) => {
  // const formData = new FormData();
  // formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
  // formData.append("Reason", Reason);
  // formData.append("SendApprovalBy", SendApprovalBy);
  return await http.put(host + "UpdateBulkHoldStatus_Aryabhatta", {_jsonUpdateBulkHoldStatus_AryabhattaList: data});
};


export const sendUpdatedFiveMReasonsToJD = async ({
  AssignContainerPlanning5mId,
  Reason,
  manualReason,
  SendApprovalBy,
}) => {
  if (Reason === "" && manualReason !== "") {
    let updatingData = {
      AssignContainerPlanning5mId:AssignContainerPlanning5mId,
      Reason : manualReason,
      SendApprovalBy
    }
    return await http.put(host + "UpdateReasonForDailyContainerPlanning5m", updatingData);
  }
  else if(Reason !== "" && manualReason !== ""){
    let updatingData = {
      AssignContainerPlanning5mId:AssignContainerPlanning5mId,
      Reason : `${Reason},${manualReason}`,
      SendApprovalBy
    }
    return await http.put(host + "UpdateReasonForDailyContainerPlanning5m", updatingData);
  }else{
    let updatingData = {
      AssignContainerPlanning5mId:AssignContainerPlanning5mId,
      Reason : `${Reason}`,
      SendApprovalBy
    }
    return await http.put(host + "UpdateReasonForDailyContainerPlanning5m", updatingData);
  }
};

export const sendFiveMBulkReasonsToJD = async (data) => {
  return await http.post(host + "InsertBulk5MBookingReason", {
    _json5mBookingReson: data,
  });
};

export const responseOnFiveMFromJD = async ({
  assignContainer5MId,
  DeereStatus,
  DeereStatusBy,
}) => {
  const formData = new FormData();
  formData.append("assignContainer5MId", assignContainer5MId);
  formData.append("DeereStatus", DeereStatus);
  formData.append("DeereStatusBy", DeereStatusBy);
  return await http.put(host + "UpdateResponse5MFromJD", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateFiveMShipment = async (data) => {
  const formData = new FormData();
  formData.append("Id", data.DailyContainerPlanning5MId);
  formData.append("ColumnName", data.ColumnName);
  formData.append("PrevVal", data.PreviousValue);
  formData.append("Value", data.Value);
  formData.append("UserId", getUser().uid);
  return await http.put(host + "UpdateSingleRowfor5M", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateFiveMShipmentForInspection = async (data) => {
  const dataObj = {
    id: data.DailyContainerPlanning5MId,
    columnName: data.ColumnName,
    prevVal: data.PrevVal,
    value: data.Value,
  };
  return await http.put(host + "updateSingleRowfor5MInspection", dataObj);
};

export const uploadFiveMBookingDocument = async (formData, dailyBookingId) => {
  return await http.put(
    host + `UpdateBookingDocument5M?Container5mId=${dailyBookingId}`,
    formData
  );
};

export const Get5MDailyPlanningDataForSubrow = async (data) => {
  const response = await http.get(host + "Get5MDailyPlanningDetailedInfo", {
    params: { dailyContainerPlanning5MId: data },
  });
  return response.data.map((item) => {
    return {
      ...item,
      ETA: standerdDate(item.ETA),
      ETD: standerdDate(item.ETD),
      Factory_In_Date: standerdDate(item.Factory_In_Date),
      Factory_Out_Date: standerdDate(item.Factory_Out_Date),
      JD_Stuffing_Date: standerdDate(item.JD_Stuffing_Date),
      Origin_Transit_Time: `${item.Origin_Transit_Time} days`,
      Ground_Rent_Days: `${item.Ground_Rent_Days} days`,
      Approx_container_detention: `${item.Approx_container_detention} days`,
    };
  });
};

export const Get5MDailyPlanningData = async (data) => {
  var planningDataArray = [];
  for (let i = 0; i < data.length; i++) {
    const response = await http.get(host + "Get5MDailyPlanningDetailedInfo", {
      params: { dailyContainerPlanning5MId: data[i] },
    });
    for (let i = 0; i < response.data.length; i++) {
      planningDataArray.push({
        ...response.data[i],
        ETA: standerdDate(response.data[i].ETA),
        ETD: standerdDate(response.data[i].ETD),
        Factory_In_Date: standerdDate(response.data[i].Factory_In_Date),
        Factory_Out_Date: standerdDate(response.data[i].Factory_Out_Date),
        JD_Stuffing_Date: standerdDate(response.data[i].JD_Stuffing_Date),
        Origin_Transit_Time: `${response.data[i].Origin_Transit_Time} days`,
        Ground_Rent_Days: `${response.data[i].Ground_Rent_Days} days`,
        Approx_container_detention: `${response.data[i].Approx_container_detention} days`,
      });
    }
  }
  return planningDataArray;
};

export const delete5MShipmentById = async (data,action) => {
  return await http.delete(host + "Delete5MDailyPlanWithId", {params:{Id : data, _DeleteforTrans : action}});
};

export const deleteFiveMDailyPlan = async (date, action) => {
  return http.delete(host + "DeleteAryabhatta5MDailyPlan", {
    params: { _date: date, _DeleteforTrans:action },
  });
};

export const deleteFiveMMonthlyPlan = async (date) => {
  return http.delete(host + "Delete5MMonthlyPlan", {
    params: { _PlanningMonth: date },
  });
};

export const getMaxFiveMContainerCount = async (date) => {
  return await http.get(host + "GetMaximumContainerCount5M", {
    params: { _date: date },
  });
};

export const updateBookingNumFiveM = async (data) => {
  const formData = new FormData();
  formData.append(
    "assignContainerPlanning5MId",
    data.assignContainerPlanning5MId
  );
  formData.append("bookingNo", data.bookingNo);
  formData.append("bookedBy", data.bookedBy);
  return await http.put(
    host + "UpdateBookingNumberForDailyContainerPlanning5M",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

const format5MData = (data) => {
  var regionWord = data.split("-");
  if (regionWord[0] && regionWord[1]) {
    return `${regionWord[0]}-${regionWord[1].trim()}`;
  } else {
    return data;
  }
};

export const DetailedMonthly5MShipmentActualData = async (data) => {
  const response = await http.get(
    host + "GetMonthly5MShipmentActualDataWithoutPlan",
    {
      params: { _planningDate: data },
    }
  );
  return response.data.map((item) => {
    return {
      ...item,
      Market: format5MData(item.Market),
      Date: standerdDateForDataCreation(item.Date),
    };
  });
};

export const update5MBulkData = async (data) => {
  await http.put(host + "UpdateBulkDataFor5M", { _json5MBookingUpList: data });
};
